var _g, _g2, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1066,
    height: 1065,
    viewBox: "0 0 1066 1065",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_864_383)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 561.684,
    cy: 481.234,
    rx: 260.684,
    ry: 204.015,
    fill: "url(#paint0_linear_864_383)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_864_383)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.43,
    y: 465.808,
    width: 250.511,
    height: 278.158,
    fill: "url(#paint1_linear_864_383)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_iii_864_383)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 568.371,
    cy: 527.5,
    rx: 183.227,
    ry: 183.227,
    transform: "rotate(120.179 568.371 527.5)",
    fill: "url(#paint2_linear_864_383)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.006 435.92L590.689 439.683L558.386 558.374L559.262 559.903L623.221 542.331L593.006 435.92Z",
    fill: "white",
    fillOpacity: 0.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.007 435.918L513.032 512.34L559.263 559.902L574.942 502.292L593.007 435.918Z",
    fill: "white",
    fillOpacity: 0.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.422 570.335L555.518 570.978L544.011 613.259L544.151 615.423L620.41 552.79L556.422 570.335Z",
    fill: "white",
    fillOpacity: 0.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.152 615.42L556.424 570.332L510.187 522.787L544.152 615.42Z",
    fill: "white",
    fillOpacity: 0.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.263 559.895L623.221 542.324L574.942 502.287L559.263 559.895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.031 512.34L559.262 559.901L574.941 502.292L513.031 512.34Z",
    fill: "white",
    fillOpacity: 0.68
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_864_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.948 604.821C588.969 657.874 513.471 668.412 460.318 628.358C407.164 588.304 396.484 512.826 436.462 459.773C476.44 406.72 551.938 396.183 605.092 436.237C658.245 476.291 668.926 551.769 628.948 604.821Z",
    fill: "url(#paint3_linear_864_383)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_864_383",
    x: 128.075,
    y: 104.294,
    width: 867.218,
    height: 753.881,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 86.4624,
    result: "effect1_foregroundBlur_864_383"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_864_383",
    x: 263.505,
    y: 292.883,
    width: 596.361,
    height: 624.007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 86.4624,
    result: "effect1_foregroundBlur_864_383"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_iii_864_383",
    x: 335.543,
    y: 273.427,
    width: 416.085,
    height: 465.656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -49.5713,
    dy: -70.8162
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 56.6658
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.676044 0 0 0 0 0.235556 0 0 0 0 0.883333 0 0 0 0.76 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_864_383"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 28.3265
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28.2975
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7625 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_864_383",
    result: "effect2_innerShadow_864_383"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.9785
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_864_383",
    result: "effect3_innerShadow_864_383"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_864_383",
    x: 0.39209,
    y: 0.0476074,
    width: 1064.63,
    height: 1064.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 205.94,
    result: "effect1_foregroundBlur_864_383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_864_383",
    x1: 561.684,
    y1: 277.219,
    x2: 561.684,
    y2: 685.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C2FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF29C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_864_383",
    x1: 561.686,
    y1: 465.808,
    x2: 561.686,
    y2: 743.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#184BFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_864_383",
    x1: 397.619,
    y1: 456.548,
    x2: 613.593,
    y2: 546.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25F5EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#DECAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#14A7B8",
    stopOpacity: 0.765238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#52CDFF",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_864_383",
    x1: 366.317,
    y1: 676.268,
    x2: 614.849,
    y2: 442.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC6AD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.091504,
    stopColor: "#DBD9DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223186,
    stopColor: "#CFD4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#F2ACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.407718,
    stopColor: "#F5B8A1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483379,
    stopColor: "#F8C494",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566846,
    stopColor: "#FCD186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#FFDE79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.725614,
    stopColor: "#FF865A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79495,
    stopColor: "#FF3A3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#3098C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882956,
    stopColor: "#6878E0",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.963542,
    stopColor: "#8021FB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.bd63b118c3f6e57868301438bc9a4cf6.svg";
export { ForwardRef as ReactComponent };